import { render, staticRenderFns } from "./News.vue?vue&type=template&id=9da62e3a"
import script from "./News.ts?vue&type=script&lang=ts&external"
export * from "./News.ts?vue&type=script&lang=ts&external"
import style0 from "./News.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports